const MOBILE_MAX_BREAKPOINT = 767;
const TABLET_MIN_BREAKPOINT = 768;
const TABLET_MAX_BREAKPOINT = 992;

function isMobile() {
    return (window.outerWidth < MOBILE_MAX_BREAKPOINT);
}

function isTablet() {
    return (window.outerWidth >= TABLET_MIN_BREAKPOINT && window.outerWidth < TABLET_MAX_BREAKPOINT);
}

function isVisible(elem) {
    return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
}

// This function is a substitute for the jQuery parents function.
function parentsUntil(el, selector) {
    const parents = [];
    while ((el = el.parentNode) && el !== document) {
        if (!selector || el.matches(selector)) parents.push(el);
    }
    return parents;
}

function nextSibling(elem, selector) {
    const nextSibling = elem.nextElementSibling;

    while (nextSibling) {
        if (nextSibling.matches(selector)) return nextSibling;
        nextSibling = nextSibling.nextElementSibling;
    }

    return false;
}

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

/**
 * Get a cookie
 * @param name - cookie name
 * @returns string
 */
function getCookie(name) {
    name = name + "=";
    const cookieStr = document.cookie.split(';');

    for (let i = 0; i < cookieStr.length; i++) {
        let cookie = cookieStr[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return "";
}

/**
 * Set a cookie
 * @param name - cookie name
 * @param value - cookie value
 * @param expireDays - expiry in days
 */
function setCookie(name, value, expireDays) {
    const currentDate = new Date();
    currentDate.setTime(currentDate.getTime() + (expireDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + currentDate.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

/**
 * @description Gets a list of query strings from the Url.
 * @return {array}
 */
function getQueryStrings() {
    const queryParams = [];
    const queryStrings = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

    for (let i = 0; i < queryStrings.length; i++) {
        const hash = queryStrings[i].split('=');
        queryParams.push(hash[0]);
        queryParams[hash[0]] = hash[1];
    }

    return queryParams;
}

/**
   * @description Gets the value of a query string parameter
   * @param {string} Name of the query string parameter
   * @return {string}
   */
function getQueryString(name) {
    return getQueryStrings()[name];
}

/**
 * @description Swaps text around in elements (typically buttons). data-current-state="" and data-next-state="" must be on the element for this to work.  
 */
function swapButtonStates(element) {
    const currentState = element.getAttribute("current-state");
    const nextState = element.getAttribute("next-state");

    if (currentState == null || nextState == null) return false;

    // Swap the buttons text around between 'more' and 'less'
    let elementHTML = element.innerHTML;
    elementHTML.replace(currentState, nextState);
    element.innerHTML(elementHTML);

    element.setAttribute("current-state", nextState);
    element.setAttribute("next-state", currentState);
}

function deviceHasTouchSupport() {
    let supportsTouch = false;

    if ('ontouchstart' in window) // iOS & android
        supportsTouch = true;
    else if (window.navigator.msPointerEnabled) // Win8
        supportsTouch = true;
    else if ('ontouchstart' in document.documentElement)
        supportsTouch = true;

    return supportsTouch;
}

// This is slightly expensive as it gets all nodes in tree, so use sparingly
function getPreviousFocusableElement(elem) {
    const focusable = Array.from(document.querySelectorAll(`
        input:not([tabindex^="-"]):not([disabled]),
        select:not([tabindex^="-"]):not([disabled]),
        textarea:not([tabindex^="-"]):not([disabled]),
        button:not([tabindex^="-"]):not([disabled]),
        a[href]:not([tabindex^="-"]):not([disabled]),
        [tabindex]:not([tabindex^="-"]):not([disabled])
    `)).filter(elem => elem.offsetParent !== null); // Filter checks that item isnt display none

    if (focusable.length == 0) {
        console.warn("No focusable elements found");
        return null;
    }

    const currentIndex = focusable.indexOf(elem);

    if (currentIndex == 0) {
        return focusable[focusable.length - 1];
    } else {
        return focusable[currentIndex - 1];
    }
}

// This is slightly expensive as it gets all nodes in tree, so use sparingly
function getNextFocusableElement(elem) {
    const focusable = Array.from(document.querySelectorAll(`
        input:not([tabindex^="-"]):not([disabled]),
        select:not([tabindex^="-"]):not([disabled]),
        textarea:not([tabindex^="-"]):not([disabled]),
        button:not([tabindex^="-"]):not([disabled]),
        a[href]:not([tabindex^="-"]):not([disabled]),
        [tabindex]:not([tabindex^="-"]):not([disabled])
    `)).filter(elem => elem.offsetParent !== null); // Filter checks that item isnt display none

    if (focusable.length == 0) {
        console.warn("No focusable elements found");
        return null;
    }

    const currentIndex = focusable.indexOf(elem);

    if (currentIndex < focusable.length - 1) {
        return focusable[currentIndex + 1];
    } else {
        return focusable[0];
    }
}

function getAllFocusableElementsWithinElement(container) {
    if (!container) {
        console.warn("No container element found");
        return null;
    }

    const focusable = Array.from(container.querySelectorAll(`
        input:not([tabindex^="-"]):not([disabled]),
        select:not([tabindex^="-"]):not([disabled]),
        textarea:not([tabindex^="-"]):not([disabled]),
        button:not([tabindex^="-"]):not([disabled]),
        a[href]:not([tabindex^="-"]):not([disabled]),
        [tabindex]:not([tabindex^="-"]):not([disabled])
    `)).filter(elem => elem.offsetParent !== null); // Filter checks that item isnt display none

    if (focusable.length == 0) {
        return null;
    } else {
        return focusable;
    }
}

function keyboardTrapFocusOnContainer(event, containerName) {
    const container = document.querySelector(containerName);
    if (!container) {
        throw new Error(`No container found named ${containerName} to trap keyboard focus`);
    }

    container.addEventListener("keydown", event => {
        const focusable = getAllFocusableElementsWithinElement(container);
        const firstFocusableEl = focusable[0];
        const lastFocusableEl = focusable[focusable.length - 1];

        const isTabPressed = (event.key === 'Tab' || event.keyCode === 9);
        if (isTabPressed) {
            if (event.shiftKey) { // Shift + Tab
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    event.preventDefault();
                }
            } else { // Tab
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    event.preventDefault();
                }
            }
        }
    });
}

export {
    isMobile,
    isTablet,
    parentsUntil,
    nextSibling,
    debounce,
    getCookie,
    setCookie,
    getQueryString,
    getQueryStrings,
    swapButtonStates,
    deviceHasTouchSupport,
    isVisible,
    getPreviousFocusableElement,
    getNextFocusableElement,
    getAllFocusableElementsWithinElement,
    keyboardTrapFocusOnContainer,
}